import './Textfield.css'
import React from 'react'
import PhoneInput from 'react-phone-number-input'
export default function Textfield(props) {
    return (
        <div className={`textfield-container ${props.className} ${props.error ? 'error' : ''}`}>
            <label htmlFor={props.id} className='label'>{props.label}</label>
            <input

                id={props.id}
                className='textfield'
                type="text"
                value={props.value}
                placeholder={props.label}
                onChange={props.onChange}
                onBlur={props.onBlur}
                required={true}

            />
            <div className='error fw-semibold fs-small'>{props.error}</div>
        </div>
    )
}


function TextfieldPhone(props) {
    return (
        <div className={
            `textfield-container 
            ${props.className} 
            ${props.error ? 'error' : ''}`
        }>
            <label
                htmlFor={props.id}
                className='label'>
                {props.label}
            </label>
            <PhoneInput

                international
                defaultCountry='IN'
                countryCallingCodeEditable={false}
                placeholder={props.label}
                value={props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
                limitMaxLength={true}


            />
            <div className='error fw-medium fs-small'>{props.error}</div>
        </div>
    )
}
export { TextfieldPhone }

